import { frontendURL } from '../../../helper/URLHelper';
import TasksIndex from './pages/TasksIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tasks'),
    component: TasksIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'tasks_dashboard_index',
        component: TasksIndex,
        meta: commonMeta,
      },
    ],
  },
];
